export default "__VITE_ASSET__7be0e091__"